'use client';

import CookieConsent from 'react-cookie-consent';
import Link from 'next/link';

const CookieConsentBanner = () => {
    return (
        <CookieConsent
            enableDeclineButton
            flipButtons
            location="bottom"
            buttonText="Accept Cookies"
            declineButtonText="Reject Non-Essential"
            cookieName="cookie-consent"
            style={{
                background: '#2d2d2d',
                alignItems: 'center',
                fontSize: '14px',
            }}
            buttonStyle={{
                background: '#A3C159',
                color: '#000',
                fontSize: '14px',
                fontWeight: '600',
                borderRadius: '4px',
                padding: '8px 16px',
                margin: '10px 10px 10px 0',
            }}
            declineButtonStyle={{
                background: 'transparent',
                border: '1px solid #fff',
                color: '#fff',
                fontSize: '14px',
                borderRadius: '4px',
                padding: '8px 16px',
                margin: '10px 10px 10px 0',
            }}
            expires={365}
        >
            We use cookies to improve your experience on our site. Essential
            cookies are always active. By clicking &quot;Accept Cookies&quot;,
            you consent to our use of non-essential cookies.{' '}
            <Link
                href="/legal/cookie"
                style={{ color: '#A3C159', textDecoration: 'underline' }}
            >
                Cookie Policy
            </Link>
        </CookieConsent>
    );
};

export default CookieConsentBanner;
